<template>
    <inertia-link :href="href" :class="classes">
        <slot />
    </inertia-link>
</template>

<script>
export default {
    props: ["href", "active"],

    computed: {
        classes() {
            return this.active
                ? "inline-flex items-center px-6 text-sm font-medium text-white hover:bg-secondary-dark transition duration-700 ease-in-out"
                : "inline-flex items-center px-6 text-sm font-medium text-white hover:bg-secondary-dark transition duration-700 ease-in-out";
        },
    },
};
</script>
